import { useCallback } from "react";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";

const CarouselPlayButton = props => {
  const { isPaused, setIsPaused } = props;

  const action = isPaused ? "play" : "pause";

  const t = useFormatMessage();
  const ariaLabel = t(intlMessages[action]);

  const handleClicked = useCallback(() => {
    setIsPaused(!isPaused);
  }, [isPaused, setIsPaused]);

  const iconClassName = classNames("fa", "fa-fw", "slider-play-button-icon", {
    "fa-play-circle": isPaused,
    "fa-pause-circle": !isPaused
  });

  return (
    <Button
      type="button"
      className="btn btn-unstyled margin-xs slider-play-button"
      iconClassName={iconClassName}
      screenReaderLabel={ariaLabel}
      onClick={handleClicked}
    />
  );
};

export default CarouselPlayButton;

const intlMessages = defineMessages({
  play: {
    id: "carousel.playButton.play",
    defaultMessage: "Lancer l'animation automatique du carousel"
  },
  pause: {
    id: "carousel.playButton.pause",
    defaultMessage: "Arrêter l'animation automatique du carousel"
  }
});
